export default {
  // Page title
  'page.title': 'World Clock',
  
  // Time zones and cities
  'timezone.utc': 'UTC',
  'timezone.local': 'Local Time',
  'timezone.currentTime': 'Current Time',
  'timezone.label': 'Time Zone',
  'timezone.title': '{{city}} Timezone',
  'timezone.localClockOffset': 'Local Clock Offset',
  'timezone.timeZone': 'Time zone',
  'timezone.today': 'Today',
  'timezone.hours': 'H',
  'timezone.standardTimeZone': 'Standard Time Zone',
  'timezone.daylightSavingTimeZone': 'Daylight Saving Time Zone',
  
  // City names (keeping English as standard)
  'city.newYork': 'New York',
  'city.london': 'London',
  'city.paris': 'Paris',
  'city.tokyo': 'Tokyo',
  'city.sydney': 'Sydney',
  'city.dubai': 'Dubai',
  'city.singapore': 'Singapore',
  'city.hongKong': 'Hong Kong',
  'city.shanghai': 'Shanghai',
  'city.beijing': 'Beijing',
  'city.mumbai': 'Mumbai',
  'city.moscow': 'Moscow',
  'city.berlin': 'Berlin',
  'city.losAngeles': 'Los Angeles',
  'city.chicago': 'Chicago',
  'city.toronto': 'Toronto',
  'city.vancouver': 'Vancouver',
  'city.brasilia': 'Brasília',
  'city.buenosAires': 'Buenos Aires',
  'city.cairo': 'Cairo',
  'city.istanbul': 'Istanbul',
  
  // How to use
  'howto.title': 'How to Use the Online World Clock',
  'howto.step1': 'This world clock website shows current time and world time for any city worldwide. Check time zones, world time differences, and international time instantly across the globe.',
  'howto.step2': 'The world clock homepage displays your local time plus multiple world clocks for major cities. Each world time zone shows precise time, date, and timezone offset information.',
  'howto.step3': 'Click any city name in the world clock list to view detailed time zone information. Each world time page provides comprehensive timezone data and current time for that location.',
  'howto.step4': 'Use the world clock search to find time in any global city. Perfect for checking world time zones, international time coordination, and global time management needs.',
  
  // User reviews
  'reviews.title': 'User Reviews',
  'reviews.globalBusiness': 'Essential for international business! Easily coordinate meeting times across different time zones, very convenient.',
  'reviews.travelBlogger': 'Travel planning must-have! Always know the local time at my destination, no more jet lag confusion.',
  'reviews.remoteTeam': 'Perfect for remote team collaboration! Easy to see when colleagues in different countries are working.',
  'reviews.internationalFamily': 'Great for staying connected with family abroad! Always know the best time to call without disturbing their sleep.',
  'reviews.managerZhang': 'As a project manager, this helps me schedule meetings with global clients more effectively.',
  
  // User names
  'user.globalBusiness': 'Global Business',
  'user.travelBlogger': 'Travel Blogger',
  'user.remoteTeam': 'Remote Developer',
  'user.internationalFamily': 'International Family',
  'user.managerZhang': 'Manager Zhang',
  
  // Keywords
  'keywords.worldclock': 'world clock time zones international time what time is it',
  'keywords.chinese': '世界时钟 时区 国际时间 现在几点',
  'keywords.japanese': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.spanish': 'reloj mundial zonas horarias tiempo internacional qué hora',
  'keywords.german': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.french': 'horloge mondiale fuseaux horaires temps international quelle heure',
  'keywords.russian': 'мировые часы часовые пояса международное время который час',

  // Country related
  'countriesTime': 'Time by Country',
  'timeIn': 'Time in',
  'cities': 'cities',
  'available': 'available',
  'citiesIn': 'Cities in',
  'viewDetails': 'View details',
  'countryNotFound': 'Country not found',
  'backToWorldClock': 'Back to World Clock',
  'cityNotFound': 'City not found',
  'popularCitiesIn': 'Popular Cities in',
  'currentTime': 'Current Time',
};